module.exports = __webpack_public_path__ + "img/montego-bay.bbfc8534.jpg";